const setIsTeamsAction = ({ commit }, payload): void => {
    commit("setIsTeams", payload);
};

export default {
    setIsTeamsAction
};
